import React, { FC } from 'react';
import { Badge, BadgeType } from '@components/atoms/Badge';
import { useTranslation } from 'react-i18next';

interface ProductStateBadgeProps {
    state: string;
}

export const ProductStateBadge: FC<ProductStateBadgeProps> = ({ state }) => {
    const { t } = useTranslation();

    const translations = {
        activeLabel: t('product-state.active'),
        inactiveLabel: t('product-state.inactive'),
        outOfStockLabel: t('product-state.out-of-stock'),
    };

    switch (state) {
        case 'active':
            return <Badge label={translations.activeLabel} type={BadgeType.success} icon="fa-light fa-check" />;
        case 'inactive':
            return <Badge label={translations.inactiveLabel} type={BadgeType.danger} icon="fa-light fa-xmark" />;
        case 'out_of_stock':
            return <Badge label={translations.outOfStockLabel} type={BadgeType.warning} icon="fa-light fa-gear" />;
        default:
            <></>;
    }
};
